import { Route, Routes } from "react-router-dom";

import TaskCreateScreen from "screens/App/CRM/Task/TaskCreateScreen";
import TaskDetailScreen from "screens/App/CRM/Task/TaskDetailScreen";
import TaskEditScreen from "screens/App/CRM/Task/TaskEditScreen";
import TaskListScreen from "screens/App/CRM/Task/TaskListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const TaskRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<TaskCreateScreen />} />
      <Route path=":id/edit" element={<TaskEditScreen />} />
      <Route path=":id/detail" element={<TaskDetailScreen />} />
      <Route path="list" element={<TaskListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default TaskRouter;
